export const DEFAULT_LOCALE = 'de'
export const PAGE_META_BUS = 'page-meta'
